import React from 'react'
import CircularProgress from '@material-ui/core/CircularProgress'
import './index.css'

const SparklingPreloader = () => {
	return <div className='menu-preloader'><CircularProgress /></div>
}

export default SparklingPreloader